import { useEffect } from "react";

export default function Toast({ message, show, type = "success", onClose }) {

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [show]);

  const bgColor = getBackground(type);

  return (
    <div
      style={{
        position: "fixed",
        top: "120px",
        left: "50%",
        width: "90vw",
        maxWidth: "90vw",
        transform: show ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(-14px)",
        background: bgColor,
        opacity: show ? 1 : 0,
        pointerEvents: show ? "auto" : "none",
        color: "#fff",
        padding: "14px 20px",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: "600",
        textAlign: "center",
        zIndex: 99999,
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
        boxSizing: "border-box",
        transition: "opacity 0.3s ease, transform 0.3s ease"
      }}
    >
      {message}
    </div>
  );
}

const getBackground = (type) => {
  switch (type) {
    case "success":
      return "#28a745"; // green
    case "error":
      return "#dc3545"; // red
    case "warning":
      return "#f59e0b"; // orange
    default:
      return "#333";
  }
};

const styles = {
  toast: {
    position: "fixed",
    top: "120px",
    left: "50%",
    width: "90vw",
    maxWidth: "90vw",
    textAlign: "center",
    color: "#fff",
    padding: "14px 20px",
    borderRadius: "10px",
    fontSize: "14px",
    zIndex: 9999,
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    boxSizing: "border-box",
    transition: "opacity 0.3s ease, transform 0.3s ease"
  }
};